import { Popconfirm, Button } from "antd"
import { useAuth } from "../../../contexts/auth"

export function ConfirmButton({
  icon,
  onClick,
  confirmText,
  style,
  ...props
}) {

  const auth = useAuth() || {}
  const { user } = auth
  const userAuth = user?.claims?.role === "ADMIN_AUDITOR"

  return (
    <Popconfirm
      title={confirmText}
      onConfirm={onClick}
      okText="Aceptar"
      cancelText="Cancelar">
      <Button
        style={{...style}}
        icon={icon}
        disabled={userAuth}
        {...props} />
    </Popconfirm>
  )
}
